'use strict';

function holidaysCtrl() {
  'ngInject';

  const vm = {};

  vm.bulkAddHoliday = function (staffHolidays, holidayIdx, meta) {
    for (const entity of staffHolidays.entities) {
      const holiday = entity.holidays[holidayIdx];
      if (holiday) {
        meta.holidaysToDelete[holiday.id] = true;
      }
    }
    vm.updateDeleteData(staffHolidays, meta);
  }

  vm.bulkRemoveHoliday = function (staffHolidays, holidayIdx, meta) {
    for (const entity of staffHolidays.entities) {
      const holiday = entity.holidays[holidayIdx];
      if (holiday) {
        delete meta.holidaysToDelete[holiday.id];
      }
    }
    vm.updateDeleteData(staffHolidays, meta);
  }

  vm.updateDeleteData = function (staffHolidays, meta) {
    const holidaysToDelete = Object.keys(meta.holidaysToDelete).filter(id => meta.holidaysToDelete[id]).map(id => 'Holiday-' + id);
    const holidayDeletionsByName = {};
    for (const idx in staffHolidays.holidays) {
      for (const entity of staffHolidays.entities) {
        const entityHoliday = entity.holidays[idx];
        if (entityHoliday && meta.holidaysToDelete[entityHoliday.id]) {
          const holidayName = staffHolidays.holidays[idx].display_name;
          if (holidayDeletionsByName[holidayName] === undefined) {
            holidayDeletionsByName[holidayName] = 0;
          }
          holidayDeletionsByName[holidayName]++;
        }
      }
    }
    meta.deleteData = {
      holidayIds: holidaysToDelete,
      holidayDeletionsByName,
    };
  }

  vm.clearDeleteData = function (meta) {
    meta.holidaysToDelete = {};
    meta.holidaysToDelete = {};
    meta.deleteData = {};
    meta.bulkDeleteConfirmed = false;
  }

  return vm;
}

export default holidaysCtrl;
